<template>
    <div :class="['consent-window', { 'is-settings-active': settingsActive }]">
        <transition
            name="component-fade"
            mode="out-in">
            <component
                :is="currentView"
                @onSettings="switchOnSettings"
            />
        </transition>
    </div>
</template>

<script>
import CookiesInfo from './CookiesInfo'
import CookiesSettings from './CookiesSettings'

export default {
    components: {
        CookiesInfo,
        CookiesSettings
    },
    data() {
        return {
            currentView: CookiesInfo,
            settingsActive: false
        }
    },
    methods: {
        switchOnSettings() {
            this.settingsActive = true
            this.currentView = CookiesSettings
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/_variables/color';
@import 'src/assets/scss/_variables/screen';

.consent-window {
    position: fixed;
    bottom: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
    background-color: $bg-content;
    box-shadow: rgba(0, 0, 0, 0.38) 0 3px 8px;
    padding: 20px 25px 16px;
    z-index: 100000;
    max-width: calc(100% - 164px);
    box-sizing: border-box;

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .component-fade-enter,
    .component-fade-leave-to {
        opacity: 0;
    }

    @media (max-width: 1800px) {
        max-width: calc(100% - 200px);
    }

    @media (max-width: $screen-laptop-large) {
        max-width: calc(100% - 164px);
    }

    @media (max-width: 1280px) {
        max-width: calc(100% - 60px);
    }

    @media (max-width: 640px) {
        max-width: calc(100% - 40px);
        padding: 10px 12px 8px;
    }

    @media (max-width: 500px) {
        min-width: 0;
        max-width: calc(100% - 40px);
        max-height: calc(100% - 40px);
        left: 20px;
        bottom: 40px;
        transform: none;
        overflow: auto;
    }
}
</style>
